import styled from "styled-components";
import { Link } from "react-router-dom";
import { animated } from "@react-spring/web";
import { devices } from "../../../constants/breakpoints";
import menuBg from "../../../assets/images/menuBg.png";

export const Container = styled(animated.div)`
  background-color: #fff;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 8;
  padding-top: 50px;
  box-sizing: border-box;
`;

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: stretch;
  margin-top: 50px;
  z-index: 1;

  /* button {
    z-index: 1;
  } */

  @media ${devices.mobile} {
    margin-top: 20px;
  }
`;

export const IconRow = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-top: 40px;
  z-index: 1;

  @media ${devices.mobile} {
    margin-top: 20px;
  }
`;

export const BgImg = styled.img`
  position: absolute;
  top: 0px;
  width: 100%;
  height: 450px;

  @media ${devices.mobile} {
    height: 300px;
  }
`;

export const TopDiv = styled.div`
  //background-image: url(${menuBg});

  width: 100%;
  display: flex;
  justify-content: center;
`;

export const BottomDiv = styled.div`
  margin-top: 80px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 40px;

  @media ${devices.mobile} {
    gap: 10px;
    margin-top: 20px;
  }
`;

export const StyledLink = styled.div`
  text-decoration: none;
  color: ${({ theme }) => theme.primary};
  font-size: 25px;
  z-index: 1;

  @media ${devices.mobile} {
    font-size: 20px;
  }
`;

export const LionImg = styled.img`
  position: absolute;
  bottom: 0;
  width: 30%;
  height: auto;
  left: 0;
  right: 0;
  margin: auto;

  @media ${devices.mobile} {
    width: 50%;
  }
`;

export const ProfileIcon = styled.div`
  width: 100px;
  height: 100px;
  background-color: #fff;
  border: 10px solid #f5f3fc;
  border-radius: 50%;
  position: relative;
`;

export const DefaultPrifleIcon = styled.img`
  width: 100%;
  height: 100%;
`;

export const LogoutButton = styled.button`
  height: 50px;
  width: 50px;
  position: absolute;
  bottom: -10px;
  right: -10px;
  background-color: #f5f3fc;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 30px;
    height: auto;
    margin-top: 5px;
    margin-left: 5px;
  }
`;
